import {
    ACCOUNT,
    ACCOUNT_NS,
    CATEGORIES_NS,
    CONFIGURATION,
    EMPLOYEES,
    EMPLOYEES_NS,
    MENU_NS,
    PRODUCTS,
    PRODUCTS_NS,
    PRODUCT_CATEGORIES,
    STORE_CLOSING,
    STORE_CLOSING_NS,
    STORE_CONFIG_NS,
    TABLES,
    TABLES_NS,
    USER_NS
} from '../Constants';
import { ImageType } from '../types';

const EN_TRANSLATION = {
    required_field: 'Required field',
    save: 'SAVE',
    delete: 'DELETE',
    cancel: 'CANCEL',
    username: 'USERNAME',
    password: 'PASSWORD',
    error: 'Error',
    [`${ACCOUNT_NS}.password_mismatch`]: 'Passwords not matching',
    [`${ACCOUNT_NS}.repeat_password`]: 'CONFIRM',
    [`${ACCOUNT_NS}.successful_update`]: 'Password updated successfully!',
    [`${CATEGORIES_NS}.name`]: 'NAME',
    [`${CATEGORIES_NS}.icon`]: 'ICON',
    [`${EMPLOYEES_NS}.name`]: 'NAME',
    [`${EMPLOYEES_NS}.phone`]: 'PHONE NUMBER',
    [`${USER_NS}.logged_user`]: 'LOGGED USER',
    [`${MENU_NS}.product_categories`]: 'Product categories',
    [`${MENU_NS}.products`]: 'Products',
    [`${MENU_NS}.tables`]: 'Tables',
    [`${MENU_NS}.employees`]: 'Employees',
    [`${MENU_NS}.store_configuration`]: 'Store configuration',
    [`${MENU_NS}.account_configuration`]: 'Account configuration',
    [`${MENU_NS}.store_closing`]: 'Store closing',
    [`${PRODUCTS_NS}.price_validation`]:
        'Price has to be empty when there is a default variety',
    [`${PRODUCTS_NS}.variety_validation`]: 'Can only have one default product variety',
    [`${PRODUCTS_NS}.name`]: 'NAME',
    [`${PRODUCTS_NS}.description`]: 'DESCRIPTION',
    [`${PRODUCTS_NS}.category`]: 'CATEGORY',
    [`${PRODUCTS_NS}.price`]: 'PRICE',
    [`${PRODUCTS_NS}.varieties`]: 'VARIETIES',
    [`${PRODUCTS_NS}.add_variety`]: 'Add new variety',
    [`${PRODUCTS_NS}.remove_variety`]: 'Remove variety',
    [`${PRODUCTS_NS}.default_variety`]: 'DEFAULT',
    [`${PRODUCTS_NS}.variety_name`]: 'Name',
    [`${PRODUCTS_NS}.variety_price`]: 'Price',
    [`${PRODUCTS_NS}.delete_product`]: 'Delete product',
    [`${PRODUCTS_NS}.delete_product_confirm`]:
        'Are you sure you want to delete product "{{id}} - {{name}}"? This action cannot be reverted!',
    [`${STORE_CONFIG_NS}.languages_validation`]:
        'At least one language has to be selected',
    [`${STORE_CONFIG_NS}.default_lang_ui_validation`]:
        'This language is not selected in the languages list',
    [`${STORE_CONFIG_NS}.card_payment`]: 'CARD PAYMENT',
    [`${STORE_CONFIG_NS}.pos_devices`]: 'AMOUNT OF POS DEVICES',
    [`${STORE_CONFIG_NS}.pos_movable`]: 'MOVABLE POS DEVICE',
    [`${STORE_CONFIG_NS}.free_wifi`]: 'FREE WIFI',
    [`${STORE_CONFIG_NS}.customer_ordering`]: 'CUSTOMER ORDERS ENABLED',
    [`${STORE_CONFIG_NS}.geolocation`]: 'ORDER GEOLOCATION ENABLED',
    [`${STORE_CONFIG_NS}.authentication`]: '2 FACTOR AUTHENTICATION',
    [`${STORE_CONFIG_NS}.logo`]: 'CONFIGURED LOGO',
    [`${STORE_CONFIG_NS}.languages`]: 'SELECTED LANGUAGES',
    [`${STORE_CONFIG_NS}.ui_lang`]: 'MAIN UI LANGUAGE',
    [`${STORE_CONFIG_NS}.menu_lang`]: 'MAIN MENU LANGUAGE',
    [`${STORE_CONFIG_NS}.people_table`]: 'AMOUNT OF PEOPLE PER TABLE',
    [`${STORE_CONFIG_NS}.missing_logo`]: 'You must select a logo first',
    [`${STORE_CONFIG_NS}.upload_logo_error`]:
        'An unexpected error occurred when uploading the logo',
    [`${TABLES_NS}.table_code_validation`]: 'Cannot have more than 5 characters',
    [`${TABLES_NS}.print_dimensions`]: 'PRINT DIMENSIONS',
    [`${TABLES_NS}.print_title`]: 'TABLE SELECTION',
    [`${TABLES_NS}.print_languages`]: 'PRINT LANGUAGES',
    [`${TABLES_NS}.pdf_file`]: 'PDF FILE CREATION',
    [`${TABLES_NS}.pdf_current_table`]: 'SINGLE TABLE (CURRENT)',
    [`${TABLES_NS}.pdf_all_tables`]: 'ALL TABLES',
    [`${TABLES_NS}.pdf_create`]: 'CREATE PDF',
    [`${TABLES_NS}.pdf_create_info`]:
        "AFTER COMPLETION A .ZIP FILE IS SENT TO THE USER'S CONFIGURED EMAIL",
    [`${TABLES_NS}.table_code`]: 'CODE',
    [`${TABLES_NS}.table_description`]: 'DESCRIPTION',
    [`${TABLES_NS}.table_seats`]: 'SEATS',
    [`${TABLES_NS}.table_added`]: 'Table "{{code}}" added successfully',
    [`${TABLES_NS}.table_updated`]: 'Table "{{code}}" updated successfully',
    [`${TABLES_NS}.max_lang_selection`]:
        'You can select up to 2 languages for the A7 light print dimension',
    [`${TABLES_NS}.lang_selection_validation`]:
        'You can select only 1 language for the selected print dimension',
    [`${STORE_CLOSING_NS}.message.label`]: 'MESSAGE',
    [`${STORE_CLOSING_NS}.message.displayFrom`]: 'DISPLAY MESSAGE FROM',
    [`${STORE_CLOSING_NS}.from`]: 'FROM',
    [`${STORE_CLOSING_NS}.to`]: 'TO',
    [`${STORE_CLOSING_NS}.description.label`]: 'DESCRIPTION',
    [`${STORE_CLOSING_NS}.form.invalid_display_date`]:
        'The display date cannot be after the from date',
    [`${STORE_CLOSING_NS}.form.invalid_range`]:
        'The store closing from date cannot be after the closing end date',
    [`${STORE_CLOSING_NS}.delete_closure`]: 'Delete closure entry',
    [`${STORE_CLOSING_NS}.delete_closure_confirm`]:
        'Are you sure you want to delete the closure entry "{{id}} - {{shortDescription}}"? This action cannot be reverted!',
    [`${PRODUCT_CATEGORIES}`]: 'PRODUCT CATEGORIES',
    [`${PRODUCTS}`]: 'PRODUCTS',
    [`${EMPLOYEES}`]: 'STORE EMPLOYEES',
    [`${TABLES}`]: 'STORE TABLES',
    [`${CONFIGURATION}`]: 'STORE CONFIGURATION',
    [`${ACCOUNT}`]: 'ACCOUNT CONFIGURATION',
    [`${STORE_CLOSING}`]: 'STORE CLOSING',
    [ImageType.BEER]: 'Beers',
    [ImageType.BEVERAGE]: 'Beverages',
    [ImageType.BREAKFAST]: 'Breakfast',
    [ImageType.BURGER]: 'Burgers',
    [ImageType.COCTAIL]: 'Coctails',
    [ImageType.COFFEE]: 'Coffee',
    [ImageType.FOOD]: 'Food',
    [ImageType.ICE_CREAM]: 'Ice cream',
    [ImageType.SWEETS]: 'Sweets',
    [ImageType.WINE]: 'Wines',
    [ImageType.FISH]: 'Fish',
    [ImageType.MEAT]: 'Meat',
    [ImageType.PIZZA]: 'Pizza ',
    [`${EMPLOYEES_NS}.invalid_email`]: 'Not a valid email address',
    [`${STORE_CLOSING_NS}.success`]: 'Successfully updated store closing times'
};

export default EN_TRANSLATION;
